import BlessButton from "@/components/layout/button/green-outline-btn";
import LoadingIcon from "@/components/layout/loading-icon";
import useModularPermissionsManager from "@/features/mod-perms/hooks/useModularPermissions.hook";
import { useModularPermissionsStore } from "@/features/mod-perms/stores/modular-permissions.store";
import React from "react";
import styles from "./save-changes-btn.module.scss";
import { useAccount } from "wagmi";
import { useUIStore } from "@/stores/ui-states.store";
import { ConnectButton } from "@rainbow-me/rainbowkit";

const SaveChangesBtn = () => {
  const { isDelegateContextGranted, permModRecords } =
    useModularPermissionsStore();

  const { contractClient } = useModularPermissionsManager();
  const account = useAccount();

  const handleSaveChanges = async (callback: () => void) => {
    if (!account.isConnected) return callback();
    await contractClient.savePermissionChanges(permModRecords);
  };

  if (isDelegateContextGranted())
    return (
      <ConnectButton.Custom>
        {({ openConnectModal }) => {
          return (
            <BlessButton
              size="medium"
              onClick={() => handleSaveChanges(openConnectModal)}
              disabled={permModRecords.length === 0}
              styles={{ gap: 5, height: 40, marginLeft: "auto" }}
            >
              Save changes
              <span className={styles.saveChangesBtnCount}>
                {permModRecords.length > 0 ? (
                  <>
                    (
                    {permModRecords.reduce(
                      (acc, perm) => acc + perm.ids.length,
                      0,
                    )}
                    )
                  </>
                ) : undefined}
              </span>
              {contractClient.isLoading && (
                <div className={styles.saveChangesLoadingIcon}>
                  <LoadingIcon size={30} />
                </div>
              )}
            </BlessButton>
          );
        }}
      </ConnectButton.Custom>
    );
};

export default SaveChangesBtn;
